export const Constants = {
  WeekStartsMonday: true,
  Weekdays: ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo'],
  Months: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dec']
};



// WEBPACK FOOTER //
// ./src/app/constants.ts